// extracted by mini-css-extract-plugin
export default {"rootPassword":"password_rootPassword__6rzJQ","divHomeButton":"password_divHomeButton__sVodw"};